<script setup lang="ts">
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img
import { validateUnitsMeasurement, sizeStringOrNum } from '@repo/alt/common/Utils'

defineOptions({
  name: 'UiImg',
})

const props = defineProps({
  alt: {
    type: String,
    default: null,
  },
  crossorigin: {
    type: String,
    validator: (value: string): boolean => ['anonymous', 'use-credentials'].includes(value),
    default: null,
  },
  src: {
    type: String,
    required: true,
  },
  srcset: {
    type: String,
    default: null,
  },
  decoding: {
    type: String,
    validator: (value: string): boolean => ['auto', 'sync', 'async'].includes(value),
    default: 'auto',
  },
  height: {
    type: [String, Number],
    validator: validateUnitsMeasurement,
    default: null,
  },
  width: {
    type: [String, Number],
    validator: validateUnitsMeasurement,
    default: null,
  },
  title: {
    type: String,
    default: null,
  },
  ismap: {
    type: Boolean,
    default: false,
  },
  sizes: {
    type: [String],
    default: null,
  },
  loading: {
    type: String,
    validator: (value: string): boolean => ['eager', 'lazy'].includes(value),
    default: 'lazy',
  },
  referrerpolicy: {
    type: String,
    default: null,
  },
  usemap: {
    type: String,
    default: null,
  },

})

const emit = defineEmits(['load', 'error', 'click'])

// Computed
const _width = computed(() => props.width ? sizeStringOrNum(props.width) : null)
const _height = computed(() => props.height ? sizeStringOrNum(props.height) : null)

// Methods
const handleLoad = (event: Event) => {
  emit('load', event)
}

const handleError = (event: Event) => {
  emit('error', event)
}

const handleClick = (event: Event) => {
  emit('click', event)
}
</script>

<template>
  <img
    :src="src"
    :alt="alt"
    :title="title"
    :width="_width || undefined"
    :height="_height || undefined"
    :loading="(loading as any)"
    :decoding="(decoding as any)"
    :referrerpolicy="(referrerpolicy as any)"
    :crossorigin="(crossorigin as any)"
    :usemap="usemap"
    :ismap="ismap"
    @load="handleLoad"
    @error="handleError"
    @click="handleClick"
  >
</template>
